import { CompanyInfoModel, CompanySummaryModel, RevenueModel } from "../../app/data/account-details/models";
import { InvoiceResponseModel } from "../../app/data/documents/models";

export default interface AccountDetailsState {
  request: {
    [key: string]: {
      requestStarted: boolean;
      requestSucceed: boolean;
      requestFailed: boolean;
      requestError?: string | null;
    }
  };
  requestScroll: {
    [key: string]: { lastIds: string, loadedAll: boolean, page?: number } | null
  };
  companyInfo: CompanyInfoModel | null;  
  companySummary: CompanySummaryModel | null;
  accounts: any[];
  revenue: RevenueModel | null;
  invoices: InvoiceResponseModel[];
};

export const initialAccountDetailsState: AccountDetailsState = {
  request: {},
  requestScroll: {},
  companyInfo: null,
  companySummary: null,
  accounts: [],
  revenue: null,
  invoices: [],
};